//En esta seccion se agregan los metodos para realizar las peticiones al servidor

import { request } from "../libs/http/http"

// Metodo para solicitar el listado de los objetos de las diferentes colecciones
export const getPatronestado = (collection, data={}) =>{
    return request('post',`/${collection}/ConsultarEstado`,data);
}

export const postPatronesBasico = (data={}) =>{
    return request('post',`/Patrones/basico`,data);
}

// Obtener equipos en laboratorio (con fechaIngreso y sin fechaSalida)
export const postEquiposEnLaboratorio = () => {
    return request('post', `/EqInOt/en-laboratorio`);
}

/**
 * Obtiene, para cada equipo activo del cliente, su última calibración
 * (endpoint del tab "Últimas Cal." en AgregarEquiposOt).
 * IMPORTANTE: `request()` NO desenvuelve el body — el consumidor debe leer
 * `response.data.data` y `response.data.resumen`.
 * @param {{ clienteId: string, umbralVencimientoDias?: number }} data
 */
export const getUltimasCalibraciones = (data = {}) => {
    return request('post', `/EqInOt/ultimas-calibraciones`, data);
}

// Metodo para solicitar el listado de los objetos de las diferentes colecciones
export const getDataList = (collection, data={}) =>{
    return request('post',`/${collection}/listar`,data);
}

// Buscar items activos por nombre (mínimo 3 chars, case-insensitive)
export const buscarItemsPorNombre = (nombre, limit = 20) => {
    return request('get', `/Items/?nombre=${encodeURIComponent(nombre)}&limit=${limit}`);
}

// Metodo para traer todas las actividades abiertas 

export const getActividadesOpen = () =>{
    return request('get',`/Actividad/actividadesAbiertas`);
}

export const getDatacalendario = (data={}) =>{
    return request('post',`/Programacion/calendario`,data);
}

// Calendario dinámico — devuelve array plano de eventos para un rango de fechas
export const getEventosCalendario = (data={}) =>{
    return request('post',`/Programacion/calendario`,data);
}

// Reprogramar un Registro (solicitante/responsable)
export const reprogramarRegistro = (id, data={}) =>{
    return request('put',`/Registro/reprogramar/${id}`,data);
}

// Cancelar un Registro
export const cancelarRegistro = (id, data={}) =>{
    return request('put',`/Registro/cancelar/${id}`,data);
}

// Reprogramar una Programación (responsable)
export const reprogramarProgramacion = (id, data={}) =>{
    return request('put',`/Programacion/reprogramar/${id}`,data);
}

// Google Calendar OAuth — obtener URL de autenticación
export const googleAuthConnect = () =>{
    return request('get',`/google/auth`);
}

// Google Calendar — desconectar cuenta
export const googleDisconnect = () =>{
    return request('delete',`/google/disconnect`);
}

// Google Calendar — verificar estado de conexión
export const googleStatus = () =>{
    return request('get',`/google/status`);
}

export const getConsultarAgenda = (data={}, id) =>{
    return request('post',`/Programacion/agenda/${id}`,data);
}

//Con esta ruta consulto el lote de equipos cargados con archivo, verifico que no esten creados.
export const consultarLoteEq = (collection, data={}) =>{
    return request('post',`/${collection}/consultarLote`,data);
}

export const getDataobtener = (id) =>{
    return request('get',`/Ot/obtener/${id}`); 
}

export const getDataObtenerUno = (collection,data) =>{
    return request('post',`/${collection}/obtenerUno`,data);
}
//metodo para pedir clientes con filtro, en la data viene el filtro que se desea pedir
export const postDataClientes = (data) =>{
    return request('post',`usuarios/filtro`,data);
}
//metodo para pedir filtro de OT por estados 
export const filtroEstadosOt = (data) =>{
    return request('post',`Ot/indicadorEstados`,data);
}
//Buscar Ot por text (consecutivo, cliente, ciudad)
export const filtroOTTexto = (data) =>{
    return request('post',`Ot/buscar/parent`,data);
}
//metodo para pedir Equipos con filtro, en la data viene el filtro que se desea pedir
export const postDataEquipos = (data) =>{
    return request('post',`Equipos/listar`,data);
}
export const actualizarDatos = (collection,data,id) => {
    return request('put',`/${collection}/actualizar/${id}`,data)
}
export const reprogramarOt = (id, data) => {
    return request('put', `/Ot/reprogramar/${id}`, data);
}
export const getVisitaVigente = ({ programacionId, otId } = {}) => {
    const param = programacionId
        ? `programacionId=${programacionId}`
        : `otId=${otId}`;
    return request('get', `/Visita/vigente?${param}`);
}
export const getVisitaUltima = ({ programacionId, otId } = {}) => {
    const param = programacionId
        ? `programacionId=${programacionId}`
        : `otId=${otId}`;
    return request('get', `/Visita/ultima?${param}`);
}
export const getMetrologos = () => request('get', '/Visita/metrologos');
export const actualizarEquipo = (collection,data,id) => {
    return request('put',`/${collection}/actualizarUser/${id}`,data)
}
export const aprobarEquipo = (collection,data) => {
    return request('put',`/${collection}/aprobar`,data)
}
export const buscarConsecutivo = (collection,data) => {
    return request('post',`/${collection}/consecutivo`,data);
}
export const actualizarEqOt = (collection,data,id,numeroOrden) => {
    return request('put',`/${collection}/actualizar/${id}?orden=${numeroOrden}`,data)
}

export const cancelarEquipo = (collection,data,id,numeroOrden) => {
    return request('put',`/${collection}/deleteEquipos/${id}?orden=${numeroOrden}`,data)
}

export const actualizarOt = (collection,data,id) => {
    return request('put',`/${collection}/actualizarEquipos/${id}`,data)
}
export const reactivarOt = (collection,data,id) => {
    return request('put',`/${collection}/reactivar/${id}`,data)
}
export const actualizarEntrega = (collection,data,id) => {
    return request('put',`/${collection}/actualizarEntrega/${id}`,data)
}
export const crearDatos = (collection,data) => {
    return request('post',`/${collection}/crear`,data)
}

// eliminar datos por id
export const eliminarDatos = (collection, id) => {
    return request('delete', `/${collection}/delete/${id}`);
}

// Notas de una solicitud (Registro). Creador + aprobadores pueden interactuar.
export const agregarNotaRegistro = (registroId, descripcion) => {
    return request('post', `/Registro/${registroId}/notas`, { descripcion });
}
export const editarNotaRegistro = (registroId, notaId, descripcion) => {
    return request('put', `/Registro/${registroId}/notas/${notaId}`, { descripcion });
}
export const eliminarNotaRegistro = (registroId, notaId) => {
    return request('delete', `/Registro/${registroId}/notas/${notaId}`);
}

export const postDataMagnitud = (data) =>{
    return request('post',`magnitud/crear`,data);
}

export const postDataItem = (data) =>{
    return request('post',`Items/crear`,data);
}
export const postIngreso = (data) =>{
    return request('post',`IngresoEquipos/crear`,data);
}

export const postDataEquipo = (data) =>{
    return request('post',`Equipos/crear`,data);
}

export const postDataEquiposlotes = (data) =>{
    return request('post',`Equipos/crear/lote`,data);
}

export const crearLotes = (collection,data) =>{
    return request('post',`/${collection}/crear/lote`,data);
}
export const postDataOt = (data) =>{
    return request('post',`Ot/crear`,data);
}

export const filterData = (collection,data) =>{
    return request('post',`/${collection}/filtro`,data);
}
//dashboard
export const dateByResponsable = (collection,data) =>{
    return request('post',`/${collection}/dateByResponsable`,data);
}
export const deleteById = (collection, id) => {
    return request('delete', `/${collection}/delete/${id}`);
}


export const addEquipments = (ot_id,orden,type,body) =>{
    return request('post',`/Ot/addEquipos/${ot_id}?orden=${orden}&type=${type}`,body)
}

// Resolver equipos dependientes antes de agregar a una OT
// (spec items-adicionales-equipo-dependiente). Devuelve grupos padre → hijos
// con dependientes NO seleccionados para abrir ModalConfirmarDependientes.
export const resolverDependientesEquipos = (equipoIds) => {
    return request('post', '/Equipos/resolver-dependientes', { equipoIds })
}

// Devuelve el grupo padre-hijos de un equipo físico (spec sincronizacion-cancelacion).
// Response: { equipo, padre, hijos }
export const obtenerGrupoFisicoEquipo = (equipoId) => {
    return request('post', '/Equipos/grupo-fisico', { equipoId })
}

// Consulta si los equipos sobre los que se va a operar en una OT tienen pareja
// (padre + hermanos) DENTRO de la misma OT. Spec: equipos-dependientes-sincronizacion-cancelacion.
//
// `excluirEstados` (opcional) controla qué estados de la pareja se ignoran:
//   - default (undefined): backend excluye ['Cancelado'] (útil para flujo cancelar).
//   - `[]`: no filtra por estado (útil para "Activar" — necesita ver pareja cancelada).
//   - `['Cancelado', 'Aprobado']`: filtro custom.
export const consultarCancelacionDependientesOt = (otId, equipoInOtIds, excluirEstados) => {
    const body = { equipoInOtIds };
    if (Array.isArray(excluirEstados)) body.excluirEstados = excluirEstados;
    return request('post', `/Ot/consultar-cancelacion-dependientes/${otId}`, body);
}

// Agregar equipos a una programación
export const addEquiposProgramacion = (id, data) => {
    return request('post', `/Programacion/addEquipos/${id}`, data);
}

export const removeEquipoFromOt = (otId, eqInOtId) =>
    request('delete', `/Ot/removeEquipo/${otId}/${eqInOtId}`)

export const deactivateOt = (id) =>{
    return request('put',`Ot/deactivate/${id}`)
}

export const getObtenerPame = (body,id) =>{
    return request('post',`/Actividad/consutarPame/${id}`,body);
}


// ==================== MÉTODOS PARA FILTRO EN INGRESOS ===============
export const postEntryEquipmentFilters = (data = {}) => {
    return request('post', '/IngresoEquipos/consultar/filtros', data);
}

export const postEntryEquipmentByOrder = (numeroOrden, extraFiltros = {}) => {
    return request('post', '/IngresoEquipos/consultar/filtros', {
        filtros: { numeroOrden, ...extraFiltros }
    });
}

export const postEntryEquipmentByClient = (clienteId, extraFiltros = {}) => {
    return request('post', '/IngresoEquipos/consultar/filtros', {
        filtros: { clienteId, ...extraFiltros }
    });
}
// ==================== PLANTILLAS DE PROCEDIMIENTO ====================

// Crear plantilla de procedimiento
export const postPlantillaProcedimiento = (data = {}) => {
    return request('post', `/plantillas-procedimiento`, data);
}

// Obtener todas las plantillas activas
export const getPlantillasProcedimiento = () => {
    return request('get', `/plantillas-procedimiento`);
}

// Obtener plantilla por ID
export const getPlantillaProcedimientoById = (id) => {
    return request('get', `/plantillas-procedimiento/${id}`);
}

// Actualizar plantilla
export const putPlantillaProcedimiento = (id, data = {}) => {
    return request('put', `/plantillas-procedimiento/${id}`, data);
}

// Desactivar plantilla
export const patchDesactivarPlantilla = (id) => {
    return request('patch', `/plantillas-procedimiento/${id}/desactivar`);
}

// ==================== MEDICIÓN EN LOTE DE CALIBRACIÓN ====================

// Crear lote de calibración
export const postLoteCalibracion = (data = {}) => {
    return request('post', `/lotes-calibracion`, data);
}

// Obtener todos los lotes
export const getLotesCalibracion = () => {
    return request('get', `/lotes-calibracion`);
}

// Obtener lote por ID
export const getLoteCalibracionById = (id) => {
    return request('get', `/lotes-calibracion/${id}`);
}

// Actualizar condiciones ambientales
export const patchCondicionesAmbientales = (id, data = {}) => {
    return request('patch', `/lotes-calibracion/${id}/condiciones-ambientales`, data);
}

// Cambiar la plantilla de un LoteCalibracion en estado 'en_progreso'.
// Body: { plantillaId, reemplazarMediciones }.
// Spec: openspec/changes/lotes-tabs-refresh-plantilla/specs/lotes-cambio-plantilla-post-confirmacion
export const cambiarPlantillaLote = (loteId, data = {}) => {
    return request('patch', `/lotes-calibracion/${loteId}/plantilla`, data);
}

// Actualizar los patrones seleccionados de un LoteCalibracion (paso 1 del stepper).
// Body: { patrones: [{patronId, codigo, nombre, descripcion, serie}, ...] }.
// Spec: openspec/changes/lotes-tabs-refresh-plantilla/specs/lotes-paso-patrones-corregido
export const patchPatronesLote = (loteId, data = {}) => {
    return request('patch', `/lotes-calibracion/${loteId}/patrones`, data);
}

/*router.patch(
    '/:id/sesiones/:sesionIndex/actualizar-puntos',
    controller.actualizarPuntosCalibracionBulk
);*/

export const patchPuntosCalibracion = (id, sesionIndex, data = {}) => {
    return request('patch', `/lotes-calibracion/${id}/sesiones/${sesionIndex}/actualizar-puntos`, data);
}

// Actualizar mediciones de estabilidad
export const patchEstabilidad = (id, sesionIndex, data = {}) => {
    return request('patch', `/lotes-calibracion/${id}/sesiones/${sesionIndex}/estabilidad`, data);
}

// Actualizar mediciones de patrón
export const patchMedicionPatron = (id, sesionIndex, data = {}) => {
    return request('patch', `/lotes-calibracion/${id}/sesiones/${sesionIndex}/patron`, data);
}

// Marcar sesión como completada
export const patchCompletarSesion = (id, sesionIndex) => {
    return request('patch', `/lotes-calibracion/${id}/sesiones/${sesionIndex}/completar`);
}

// Finalizar lote (mantiene PATCH por compat; POST también soportado backend)
export const patchFinalizarLote = (id) => {
    return request('patch', `/lotes-calibracion/${id}/finalizar`);
}

// Finalizar lote con orquestación multi-OT (Feat C). Acepta `omitirValidacion:boolean`.
export const finalizarLoteCalibracion = (loteId, opciones = {}) => {
    return request('post', `/lotes-calibracion/${loteId}/finalizar`, opciones);
}

// Actualizar lote de calibración (editar metadatos, equipos, responsable)
export const putLoteCalibracion = (id, data = {}) => {
    return request('put', `/lotes-calibracion/${id}`, data);
}

// ==================== RUTAS BULK NUEVAS ====================

// Crear lotes en bulk (uno por cada equipo)
export const postLotesCalibracionBulk = (data = {}) => {
    return request('post', `/lotes-calibracion/bulk`, data);
}

// Actualizar condiciones ambientales en todos los lotes del grupo
export const patchCondicionesBulk = (loteEquiposId, data = {}) => {
    return request('patch', `/lotes-calibracion/bulk/${loteEquiposId}/condiciones`, data);
}

// Actualizar estabilidad en todos los lotes del grupo
export const patchEstabilidadBulk = (loteEquiposId, data = {}) => {
    return request('patch', `/lotes-calibracion/bulk/${loteEquiposId}/estabilidad`, data);
}

// Actualizar mediciones de patrones en todos los lotes del grupo
export const patchPatronesBulk = (loteEquiposId, sesionIndex, data = {}) => {
    return request('patch', `/lotes-calibracion/bulk/${loteEquiposId}/sesiones/${sesionIndex}/patron`, data);
}

// Finalizar todos los lotes del grupo (mantiene PATCH por compat)
export const patchFinalizarLotesBulk = (loteEquiposId) => {
    return request('patch', `/lotes-calibracion/bulk/${loteEquiposId}/finalizar`);
}

// Finalizar bulk con orquestación multi-OT (Feat C). `opciones` puede contener `omitirValidacion:boolean`.
export const finalizarLotesBulkCalibracion = (loteEquiposId, opciones = {}) => {
    return request('post', `/lotes-calibracion/bulk/${loteEquiposId}/finalizar`, opciones);
}

// ==================== HOJAS DE TRABAJO (Feat C) ====================

// Listar hojas de una OT
export const getHojasTrabajoPorOt = (otId) => {
    return request('get', `/hojas-trabajo/ot/${otId}`);
}

// Detalle de una hoja de trabajo
export const getHojaTrabajoDetalle = (id) => {
    return request('get', `/hojas-trabajo/${id}`);
}

// Anular hoja de trabajo (body: { motivoAnulacion: string })
export const anularHojaTrabajo = (id, motivoAnulacion) => {
    return request('patch', `/hojas-trabajo/${id}/anular`, { motivoAnulacion });
}

// ==================== RUTAS INDIVIDUALES (YA EXISTENTES) ====================

// Actualizar mediciones IBC de un equipo específico
export const patchMedicionIBC = (id, sesionIndex, data = {}) => {
    return request('patch', `/lotes-calibracion/${id}/sesiones/${sesionIndex}/ibc`, data);
}


// ==================== LOTES DE CALIBRACIÓN - CONSULTAS ADICIONALES ====================

// Obtener lotes de calibración por lote de equipos (loteEquiposId)
export const getLotesCalibracionByLoteEquipos = (loteEquiposId) => {
    return request('get', `/lotes-calibracion/por-lote-equipos/${loteEquiposId}`);
}

// ==================== LOTES DE LABORATORIO (LotCalLab) ====================

// Crear lote de laboratorio
export const postLoteLab = (data = {}) => {
    return request('post', `/lotes-lab`, data);
}

// Listar lotes con filtros opcionales
export const postListarLotesLab = (data = {}) => {
    return request('post', `/lotes-lab/listar`, data);
}

// Obtener lotes por responsable
export const postLotesLabPorResponsable = (data = {}) => {
    return request('post', `/lotes-lab/por-responsable`, data);
}

// Obtener lote por ID
// Anular un lote de laboratorio (solo si estado === 'pendiente').
// Elimina los LoteCalibracion hijos y libera los equipos.
export const anularLoteLab = (id) => {
    return request('patch', `/lotes-lab/${id}/anular`);
}

export const getLoteLabById = (id) => {
    return request('get', `/lotes-lab/${id}`);
}

// Actualizar lote
export const putLoteLab = (id, data = {}) => {
    return request('put', `/lotes-lab/${id}`, data);
}

// Agregar equipo al lote
export const patchAgregarEquipoLote = (id, data = {}) => {
    return request('patch', `/lotes-lab/${id}/agregar-equipo`, data);
}

// Remover equipo del lote
export const patchRemoverEquipoLote = (id, data = {}) => {
    return request('patch', `/lotes-lab/${id}/remover-equipo`, data);
}

// Cambiar estado del lote
export const patchEstadoLoteLab = (id, data = {}) => {
    return request('patch', `/lotes-lab/${id}/estado`, data);
}

// Cerrar lote
export const patchCerrarLoteLab = (id) => {
    return request('patch', `/lotes-lab/${id}/cerrar`);
}

// ==================== FIRMA REMOTA ====================

// Solicitar firma remota del cliente para una Hoja de Trabajo completa (envía email con link)
export const requestFirmaRemotaHT = (htId, email) => {
    return request('post', `/Ot/${htId}/firma-remota/solicitar`, { email });
}

// Reenviar email de firma remota para una Hoja de Trabajo (con opción de cambiar email)
export const resendFirmaRemotaHT = (htId, newEmail = null) => {
    return request('post', `/Ot/${htId}/firma-remota/reenviar`, { newEmail });
}

// Enviar PDF de Hoja de Trabajo firmada por correo electrónico
export const sendPdfEmailHT = (htId, email) => {
    return request('post', `/Ot/${htId}/enviar-pdf-email`, { email });
}

// Obtener datos de HT para firma pública (sin autenticación)
export const getFirmaData = (token) => {
    return request('get', `/Ot/firma-remota/${token}`);
}

// Enviar firma del cliente para HT (sin autenticación)
export const submitFirma = (token, firmaUrl, persona, cargo) => {
    return request('post', `/Ot/firma-remota/${token}/firmar`, { token, firmaUrl, persona, cargo });
}

// Descargar PDF de HT firmada por token (sin autenticación)
export const downloadFirmaPdf = (token) => {
    return request('get', `/Ot/firma-remota/${token}/pdf`, {}, { responseType: 'blob' });
}

/// Cuetas contables

export const listarPorClases = (clase={}) =>{
    return request('get',`/CuentasContables/clase/${clase}`);
}

// Agregar estas funciones al archivo existente src/api/common.js

// ==================== PROPUESTAS ====================

export const crearPropuesta = async (data) => {
  return await request({
    url: '/propuestas/crear',
    method: 'POST',
    data
  });
};

export const listarPropuestas = async (params) => {
  return await request({
    url: '/propuestas/listar',
    method: 'POST',
    data: params
  });
};

export const obtenerPropuesta = async (id) => {
  return await request({
    url: `/propuestas/obtener/${id}`,
    method: 'GET'
  });
};

export const actualizarPropuesta = async (id, data) => {
  return await request({
    url: `/propuestas/actualizar/${id}`,
    method: 'PUT',
    data
  });
};

export const eliminarPropuesta = async (id) => {
  return await request({
    url: `/propuestas/eliminar/${id}`,
    method: 'DELETE'
  });
};

export const enviarPropuesta = async (id, data = {}) => {
  return await request({
    url: `/propuestas/enviar/${id}`,
    method: 'PUT',
    data
  });
};


export const obtenerVersionesPropuesta = async (id) => {
  return await request({
    url: `/propuestas/versiones/${id}`,
    method: 'GET'
  });
};

export const obtenerIndicadoresPropuestas = async (filtros = {}) => {
  return await request({
    url: '/propuestas/indicadores',
    method: 'POST',
    data: { filtros }
  });
};

// Rutas públicas (sin autenticación)
export const obtenerPropuestaPorToken = async (token) => {
  return await request({
    url: `/propuestas/public/${token}`,
    method: 'GET'
  });
};

export const aprobarPropuesta = async (token, nombreAprobador) => {
  return await request({
    url: `/propuestas/public/${token}/aprobar`,
    method: 'POST',
    data: { nombre_aprobador: nombreAprobador }
  });
};

export const rechazarPropuesta = async (token, motivoRechazo, nombreRechazo) => {
  return await request({
    url: `/propuestas/public/${token}/rechazar`,
    method: 'POST',
    data: { motivo_rechazo: motivoRechazo, nombre_rechazo: nombreRechazo }
  });
};

export const solicitarCambiosPropuesta = async (token, solicitudes) => {
  return await request({
    url: `/propuestas/public/${token}/solicitar-cambios`,
    method: 'POST',
    data: { solicitudes }
  });
};

export const autorizarPropuesta = async (id) => {
  return await request({
    url: `/propuestas/autorizar/${id}`,
    method: 'PUT'
  });
};

export const procesarCambiosPropuesta = async (id) => {
  return await request({
    url: `/propuestas/procesar-cambios/${id}`,
    method: 'PUT'
  });
};

export const reactivarPropuesta = async (id, data) => {
  return await request({
    url: `/propuestas/reactivar/${id}`,
    method: 'PUT',
    data
  });
};

export const validarSincronizacionPropuesta = async (id) => {
  return await request({
    url: `/propuestas/validar-sync/${id}`,
    method: 'GET'
  });
};

export const sincronizarPropuestaContable = async (id) => {
  return await request({
    url: `/propuestas/sincronizar/${id}`,
    method: 'POST'
  });
};

export const obtenerPlantillaActiva = async () => {
  return await request({
    url: '/PlantillaPropuesta/activa',
    method: 'GET'
  });
};

export const obtenerPlantillaUnica = async () => {
  return await request({
    url: '/PlantillaPropuesta/unica',
    method: 'GET'
  });
};

export const actualizarPlantillaUnica = async (data) => {
    console.log('Actualizando plantilla única con data:', data);
  return await request({
    url: '/PlantillaPropuesta/unica',
    method: 'PUT',
    data
  });
};

export const listarPlantillas = async () => {
  return await request({
    url: '/PlantillaPropuesta/listar',
    method: 'POST',
    data: {}
  });
};

export const crearPlantilla = async (data) => {
  return await request({
    url: '/PlantillaPropuesta/crear',
    method: 'POST',
    data
  });
};

export const actualizarPlantilla = async (id, data) => {
  return await request({
    url: `/PlantillaPropuesta/actualizar/${id}`,
    method: 'PUT',
    data
  });
};

export const activarPlantilla = async (id) => {
  return await request({
    url: `/PlantillaPropuesta/activar/${id}`,
    method: 'POST'
  });
};

// ==================== FIREBASE STORAGE (via backend) ====================

/**
 * Sube un archivo al backend que lo almacena en Firebase Storage.
 * @param {File} file  Objeto File del input
 * @param {string} folder  Carpeta en el bucket: 'propuestas', 'plantillas', etc.
 * @returns {Promise<string>} URL pública del archivo
 */
export const subirArchivoStorage = async (file, folder = 'general') => {
  const formData = new FormData();
  formData.append('file', file);
  return await request({
    url: `/StorageFirebase/upload?folder=${folder}`,
    method: 'POST',
    data: formData,
    // No fijar Content-Type: el navegador lo establece automáticamente
    // con el boundary correcto (multipart/form-data; boundary=...)
  });
};

export const eliminarArchivoStorage = async (url) => {
  return await request({
    url: '/StorageFirebase/delete',
    method: 'DELETE',
    data: { url },
  });
};

export const eliminarArchivoPublicoCliente = async (token, url) => {
  return await request({
    url: `/StorageFirebase/delete/public/${token}`,
    method: 'DELETE',
    data: { url },
  });
};

// Upload público (cliente) — no requiere JWT
export const subirArchivoPublicoCliente = async (token, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return await request({
    url: `/StorageFirebase/upload/public/${token}`,
    method: 'POST',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const subirArchivoPublicoRequisicion = async (token, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return await request({
    url: `/StorageFirebase/upload/public/requisicion/${token}`,
    method: 'POST',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

// TIN-23 A3: Upload interno autenticado para archivos de una requisición.
// Cada archivo queda en /requisiciones/{CONSECUTIVO}/{subcarpeta}/.
// Subcarpetas permitidas: 'orden-compra', 'certificados', 'cotizaciones',
// 'adjuntos', 'evidencias'.
export const subirArchivoRequisicion = async (requisicionId, subcarpeta, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return await request({
    url: `/StorageFirebase/upload/requisicion/${requisicionId}/${subcarpeta}`,
    method: 'POST',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const eliminarArchivoPublicoRequisicion = async (token, url) => {
  return await request({
    url: `/StorageFirebase/delete/public/requisicion/${token}`,
    method: 'DELETE',
    data: { url },
  });
};

export const subirCertificadoPublicoRequisicion = async (token, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return await request({
    url: `/StorageFirebase/upload/public/requisicion/${token}/certificados`,
    method: 'POST',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

// ==================== PROPUESTA ARCHIVOS / IDS ====================

/**
 * Reserva un ObjectId valido sin crear documento en la coleccion Propuestas.
 * Se usa antes de subir la primera evidencia del formulario de crear, para que
 * el archivo quede en `propuestas/{_id}/origen/` aunque la propuesta aun no exista
 * en MongoDB. Despues, el `_id` reservado se envia como campo `_id` en el body
 * del POST /Propuestas/crear y el backend lo respeta al construir el documento.
 */
export const reservarIdPropuesta = async () => {
  return await request({
    url: '/Propuestas/reservar-id',
    method: 'POST',
  });
};

/**
 * Sube un archivo asociado a una propuesta (estructura scoped por _id).
 * Cada archivo queda en `propuestas/{propuestaId}/{subcarpeta}/`.
 * Subcarpetas permitidas: 'origen', 'evidencias-cambio', 'adjuntos'.
 * Los adjuntos del cliente desde el link publico usan subirArchivoPublicoCliente
 * y se enrutan en backend a `propuestas/{_id}/cliente/`.
 */
export const subirArchivoPropuesta = async (propuestaId, subcarpeta, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return await request({
    url: `/StorageFirebase/upload/propuesta/${propuestaId}/${subcarpeta}`,
    method: 'POST',
    data: formData,
  });
};

// ==================== PROPUESTA ADJUNTOS ====================

export const agregarAdjuntoPropuesta = async (id, url) => {
  return await request({
    url: `/Propuestas/${id}/adjuntos`,
    method: 'POST',
    data: { url },
  });
};

export const eliminarAdjuntoPropuesta = async (id, url) => {
  return await request({
    url: `/Propuestas/${id}/adjuntos`,
    method: 'DELETE',
    data: { url },
  });
};

// ==================== SIIGO ====================


/** busco un tercero con a esta ruta 
 * router.get(
    '/buscarPorIdentification/:identification',
    validateRole(all_roles),
    controller.buscarPorIdentification
) */
export const buscarTerceroPorNit = async (nit) => {
  return await request('get', `/terceroContable/buscarPorIdentification/${nit}`)
};

export const getSiigoConfig = async () => {
  return await request('get', `/siigo/configuracion/obtener`)
};

export const saveSiigoConfig = async (data) => {  //Guadar configuracion de siigo
  return request('post',`/siigo/configuracion/guardar`,data);
};

export const validarConexionSiigo = async () => {
  return request('post',`/siigo/validar-conexion`);
};



export const consultarTaxes = async () => {
  return request('post',`/siigo/taxes`);
};

export const sincronizarProductosSiigo = async () => {
  return await request({
    url: '/siigo/sincronizar/productos',
    method: 'POST'
  });
};

export const crearFacturaSiigo = async (propuesta_id) => {
  return await request({
    url: '/siigo/crear-factura',
    method: 'POST',
    data: { propuesta_id }
  });
};

export const syncTerceroaTinvaz = async (data) => {  //Guadar configuracion de siigo
  return request('post',`/terceroContable/sync/suppliers`,data);
};



// ============================================
// PRÉSTAMOS - Funciones API
// ============================================

/**


/**
 * Crear préstamo 
 */
export const crearPrestamo = async (data) => {
  return await request('post', '/Prestamos/crear', data);
};

/**
 * Listar préstamos
 */
export const listarPrestamos = async (filtros = {}) => {
  return await request('post', '/Prestamos/listar', filtros);
};

/**
 * Filtrar préstamos
 */
export const filtrarPrestamos = async (filtros) => {
  return await request('post', '/Prestamos/filtro', filtros);
};

/**
 * Obtener OT por ID con populate completo para exportación Excel
 */
export const obtenerOtParaExcel = async (id) => {
  return await request('get', `/Ot/obtenerExcel/${id}`);
};

/**
 * Obtener préstamo por ID
 */
export const obtenerPrestamoPorId = async (id) => {
  return await request('get', `/Prestamos/obtener/${id}`);
};

/**
 * Actualizar préstamo
 */
export const actualizarPrestamo = async (id, data) => {
  return await request('put', `/Prestamos/actualizar/${id}`, data);
};

/**
 * Confirmar entrega de préstamo
 */
export const confirmarEntregaPrestamo = async (id, data) => {
  return await request('put', `/Prestamos/confirmarEntrega/${id}`, data);
};

/**
 * Recibir equipos devueltos
 */
export const recibirEquiposPrestamo = async (id, data) => {
  return await request('put', `/Prestamos/recibirEquipos/${id}`, data);
};

/**
 * Anular préstamo
 */
export const anularPrestamo = async (id, motivo) => {
  return await request('put', `/Prestamos/anular/${id}`, { motivo });
};

/**
 * Obtener préstamos por OT
 */
export const obtenerPrestamosPorOt = async (otId) => {
  return await request('get', `/Prestamos/obtenerPorOt/${otId}`);
};

/**
 * Obtener estadísticas de préstamos
 */
export const obtenerEstadisticasPrestamos = async () => {
  return await request('get', '/Prestamos/estadisticas');
};

/**
 * Listar patrones con info básica (sin autopopulate — rápido)
 * @param {Object} filters - { tipoEquipo, estado, movimiento, magnitud, inService }
 */
export const getPatronesBasico = async (filters = {}) => {
  return await request('post', '/Patrones/basico', filters);
};

/**
 * Listar patrones actualmente prestados (movimiento === 'Préstamo')
 */
export const getPatronesPrestados = async () => {
  return await request('post', '/Patrones/prestados');
};

/**
 * Generar link público para confirmación de entrega de préstamo
 * @param {string} id - ID del préstamo
 */
export const generarTokenPrestamo = async (id) => {
  return await request('post', `/Prestamos/generarToken/${id}`);
};

/**
 * Obtener datos del préstamo por token público (sin auth)
 * @param {string} token - UUID del link público
 */
export const getPrestamoPorTokenPublico = async (token) => {
  return await request('get', `/PrestamosPublico/${token}`);
};

/**
 * Confirmar entrega de equipos mediante link público (sin auth)
 * @param {string} token - UUID del link público
 * @param {Object} data - { nombreRecibe, cargoRecibe, recibidoSatisfaccion, observaciones, firma }
 */
export const confirmarEntregaPublicoAPI = async (token, data) => {
  return await request('put', `/PrestamosPublico/${token}/confirmar`, data);
};



// ============================================
// REGISTROS - SOLICITUDES - Funciones API
// ============================================



// 2. CREAR LOTE DE SOLICITUDES
export const crearSolicitudLote = (data = []) => {
    return request('post', `/Registro/crear/lote`, data);
};

// 4. FILTRAR SOLICITUDES
export const filtrarSolicitudes = (data = {}) => {
    return request('post', `/Registro/filtro`, data);
};

// 5. OBTENER UNO (POR BODY)
export const obtenerUnoSolicitud = (data = {}) => {
    return request('post', `/Registro/obtenerUno`, data);
};

// 6. OBTENER POR ID (GET)
export const obtenerSolicitudId = (id) => {
    return request('get', `/Registro/obtener/${id}`);
};

// 7. ACTUALIZAR SOLICITUD
export const actualizarSolicitud = (id, data = {}) => {
    return request('put', `/Registro/actualizar/${id}`, data);
};

// 8. ELIMINAR SOLICITUD
export const eliminarSolicitud = (id) => {
    return request('delete', `/Registro/delete/${id}`);
};

// 9. ELIMINAR SOLICITUD
export const aprobarSolicitud = (id, data = {}) => {
    return request('put', `/Registro/aprobar/${id}`, data );  
};

// 9. ELIMINAR SOLICITUD
export const rechazarSolicitud = (id, data = {}) => {
    return request('put', `/Registro/rechazar/${id}`, data );  
};

//** EndPoint Viaticos */

//PUT   
export const ViaticosAccionesPUT = (accion, data,id) => {
    return request('put',`/EgresoViatico/${accion}/${id}`,data)  
    // accion: [confirmarRecepcion,rechazar,liquidar]
}

//POST
export const ViaticosAccionesPOST = (accion, data={}, id=null) =>{
    return request('post',`/Programacion/${accion}/${id}`,data);
    // accion: [agregarAdicional,porTecnico, indicadores]
}



// ==========================================
// MÓDULO CAJA MENOR
// ==========================================

/**
 * Confirmar recepción de caja menor
 */
export const confirmarRecepcionCaja = (data) => {
    return request('post', '/CajaMenor/confirmarRecepcion', data);
}

/**
 * Obtener caja activa del usuario actual
 */
export const obtenerCajaActiva = (data = {}) => {
    return request('post', '/CajaMenor/obtenerActiva', data);
}

/**
 * Obtener movimientos de una caja específica
 */
export const obtenerMovimientosCaja = (id, data = {}) => {
    return request('post', `/CajaMenor/movimientos/${id}`, data);
}

/**
 * Cerrar caja menor
 */
export const cerrarCajaMenor = (data) => {
    return request('post', '/CajaMenor/cerrar', data);
}

/**
 * Obtener resumen completo de caja
 */
export const obtenerResumenCaja = (id, data = {}) => {
    return request('post', `/CajaMenor/resumen/${id}`, data);
}

/**
 * Generar consecutivo de caja menor
 */
export const generarConsecutivoCaja = (data = {}) => {
    return request('post', '/CajaMenor/consecutivo', data);
}

/* endpoint para viaticos */
// 'egresoViaticos/abierto/usuario/:usuarioId'
export const obtenerCajaViaticosAbiertaPorUsuario = (usuarioId) => {
    return request('get', `/egresoViaticos/abierto/usuario/${usuarioId}`);
}


//

export const confirmarTrasladoDinero = (id, data) => {
  console.log("API confirmarTrasladoDinero id:",id,"data:",data)
    return request('put', `/trasladosDinero/confirmar/${id}`, data);
}

// Rechazar traslado de dinero
export const rechazarTrasladoDinero = (id, data) => {
    return request('put', `/trasladosDinero/rechazar/${id}`, data);
}


/**
 * Cerrar caja menor con transferencia
 * POST /CajaMenor/cerrarConTransferencia
 */
export const cerrarCajaConTransferencia = (data) => {
    return request('post', '/CajaMenor/cerrarConTransferencia', data);
}

/**
 * Cerrar caja menor con devolución
 * POST /CajaMenor/cerrarConDevolucion
 */
export const cerrarCajaConDevolucion = (data) => {
    return request('post', '/CajaMenor/cerrarConDevolucion', data);
}


// ==========================================
// MÓDULO COMPROBANTE CONTABLE
// ==========================================

/**
 * Listar comprobantes de una caja específica
 */
export const listarComprobantesPorCaja = (data) => {
    return request('post', '/ComprobanteContable/listarPorCaja', data);
}

/**
 * Anular comprobante contable
 */
export const anularComprobante = (data) => {
    return request('post', '/ComprobanteContable/anular', data);
}

/**
 * Obtener resumen contable de una caja
 */
export const obtenerResumenContable = (cajaId, data = {}) => {
    return request('post', `/ComprobanteContable/resumenContable/${cajaId}`, data);
}

/**
 * Preparar comprobante para SIIGO
 */
export const prepararComprobanteParaSiigo = (id, data = {}) => {
    return request('post', `/ComprobanteContable/prepararSiigo/${id}`, data);
}

/**
 * Sincronizar comprobante con SIIGO
 */
export const sincronizarComprobanteConSiigo = (data) => {
    return request('post', '/ComprobanteContable/sincronizarSiigo', data);
}

/**
 * Generar consecutivo de comprobante
 */
export const generarConsecutivoComprobante = (data) => {
    return request('post', '/ComprobanteContable/consecutivo', data);
}

// ==================== FUNCIONES GENÉRICAS DE API ====================

/**
 * Obtener un registro específico por ID
 * @param {string} collection - Nombre de la colección
 * @param {string} id - ID del registro
 * @returns {Promise} Respuesta de la API
 */
export const getData = (collection, id) => {
    return request('get', `/${collection}/obtener/${id}`);
}

/**
 * Crear un nuevo registro (método genérico POST)
 * @param {string} endpoint - Endpoint completo o colección
 * @param {object} data - Datos a enviar
 * @returns {Promise} Respuesta de la API
 */
export const postData = (endpoint, data) => {
    // Si el endpoint ya incluye la ruta completa, usarlo directamente
    if (endpoint.includes('/')) {
        return request('post', `/${endpoint}`, data);
    }
    // Si no, asumir que es una colección y agregar /crear
    return request('post', `/${endpoint}/crear`, data);
}

/**
 * Actualizar un registro (método genérico PUT)
 * @param {string} endpoint - Endpoint completo o colección
 * @param {object} data - Datos a actualizar
 * @returns {Promise} Respuesta de la API
 */
export const putData = (endpoint, data) => {
    // Para endpoints completos
    return request('put', `/${endpoint}`, data);
}

export const patchData = (endpoint, data) => {
    // Para endpoints completos
    return request('patch', `/${endpoint}`, data);
}
// /group/:groupConsecutive/close
export const patchClose = (groupConsecutive, data) => {
    return request('patch', `/patronesMovimientos/group/${groupConsecutive}/close`, data);
}

export const getMovimientoAbiertoCount = ( ) => {
    return request('get', `/patronesMovimientos//groups/open/count`);
}

// '/ot/:otId/active',
export const movimientosByOtId = (otId) => {
    return request('get', `/patronesMovimientos/ot/${otId}/active`);
}
/**
 * Actualizar un registro por ID (método genérico PUT con ID)
 * @param {string} collection - Nombre de la colección
 * @param {string} id - ID del registro
 * @param {object} data - Datos a actualizar
 * @returns {Promise} Respuesta de la API
 */
export const updateData = (collection, id, data) => {
    return request('put', `/${collection}/actualizar/${id}`, data);
}

// ==================== SPEC 003-OPTIMIZED-OT-LIST ====================

/**
 * Búsqueda async de usuarios para filtros (spec 003-optimized-ot-list)
 * @param {string} texto - Texto de búsqueda (mínimo 3 caracteres)
 * @param {string} rol - Filtro opcional por rol (usar '~Cliente' para excluir clientes)
 * @param {number} limit - Límite de resultados (default: 20)
 * @returns {Promise} Respuesta con lista de usuarios
 */
export const buscarUsuarios = (texto, rol = null, limit = 20) => {
    const params = new URLSearchParams({ q: texto });
    if (rol) params.append('rol', rol);
    if (limit) params.append('limit', limit.toString());
    return request('get', `/Usuarios/buscar?${params.toString()}`);
}

/**
 * Búsqueda async de clientes (rol=Cliente) por identificacion, nombre o ciudad
 * @param {string} texto - Texto de búsqueda (mínimo 3 caracteres)
 * @param {number} limit - Límite de resultados (default: 20)
 * @returns {Promise} Respuesta con lista de clientes
 */
export const buscarClientes = (texto, limit = 20) =>
    buscarUsuarios(texto, 'Cliente', limit);

/**
 * Búsqueda async de sedes para filtros (spec 003-optimized-ot-list)
 * @param {string} texto - Texto de búsqueda (mínimo 3 caracteres)
 * @param {number} limit - Límite de resultados (default: 20)
 * @returns {Promise} Respuesta con lista de sedes
 */
export const buscarSedes = (texto, limit = 20) => {
    const params = new URLSearchParams({ q: texto });
    if (limit) params.append('limit', limit.toString());
    return request('get', `/Sedes/buscar?${params.toString()}`);
}

export const buscarPropuestas = (texto, limit = 20) => {
    const params = new URLSearchParams({ q: texto });
    if (limit) params.append('limit', limit.toString());
    return request('get', `/Propuestas/buscar?${params.toString()}`);
}

// descargar propuesta pdf por id /descargar/:propuestaId
export const descargarPropuestaPdf = (propuestaId) => {
    return request('get', `/Propuestas/descargar/${propuestaId}`, {}, { responseType: 'blob' });
}

/**
 * Migrar snapshots de equipos legacy (spec 003-optimized-ot-list)
 * Solo accesible para Admin
 * @param {number} batchSize - Tamaño del lote (default: 100)
 * @param {boolean} dryRun - Modo prueba sin hacer cambios (default: false)
 * @returns {Promise} Reporte de migración
 */
export const migrarSnapshotsOt = (batchSize = 100, dryRun = false) => {
    return request('post', '/Ot/migrar-snapshots', { batchSize, dryRun });
}

/**
 * Migrar snapshots de una OT específica
 * @param {string} otId - ID de la orden de trabajo
 * @returns {Promise} Respuesta de la API
 */
export const migrarSnapshotsDeOt = (otId) => {
    return request('post', `/Ot/migrar-snapshots/${otId}`);
}

// ==================== MÉTODOS HTTP GENÉRICOS ====================

/**
 * Realizar una petición GET genérica
 * @param {string} url - URL del endpoint (con o sin '/' inicial)
 * @param {object} params - Parámetros de consulta opcionales
 * @returns {Promise} Respuesta de la API
 */
export const GET = async (url, params = {}) => {
    const urlWithSlash = url.startsWith('/') ? url : `/${url}`;
    const queryString = Object.keys(params).length > 0 
        ? '?' + new URLSearchParams(params).toString() 
        : '';
    return await request('get', `${urlWithSlash}${queryString}`);
};

/**
 * Realizar una petición POST genérica
 * @param {string} url - URL del endpoint (con o sin '/' inicial)
 * @param {object} data - Datos a enviar en el cuerpo de la petición
 * @returns {Promise} Respuesta de la API
 */
export const POST = async (url, data = {}) => {
    const urlWithSlash = url.startsWith('/') ? url : `/${url}`;
    return await request('post', urlWithSlash, data);
};

/**
 * Realizar una petición PUT genérica
 * @param {string} url - URL del endpoint (con o sin '/' inicial)
 * @param {object} data - Datos a enviar en el cuerpo de la petición
 * @returns {Promise} Respuesta de la API
 */
export const PUT = async (url, data = {}) => {
    const urlWithSlash = url.startsWith('/') ? url : `/${url}`;
    return await request('put', urlWithSlash, data);
};

/**
 * Realizar una petición DELETE genérica
 * @param {string} url - URL del endpoint (con o sin '/' inicial)
 * @returns {Promise} Respuesta de la API
 */
export const DELETE = async (url) => {
    const urlWithSlash = url.startsWith('/') ? url : `/${url}`;
    return await request('delete', urlWithSlash);
};

// ==================== ACCOUNTING CONFIG ====================

export const getAccountingProviders = (params = {}) => {
    const qs = Object.keys(params).length ? '?' + new URLSearchParams(params).toString() : '';
    return request('get', `/accounting-config/providers${qs}`);
};

/** Shortcut: devuelve el proveedor activo ({_id, display_name, name}) o null */
export const getActiveProvider = () =>
    request('get', '/accounting-config/providers?active=true');
export const createAccountingProvider = (data) =>
    request('post', '/accounting-config/providers', data);
export const updateAccountingProvider = (id, data) =>
    request('put', `/accounting-config/providers/${id}`, data);
export const deleteAccountingProvider = (id) =>
    request('delete', `/accounting-config/providers/${id}`);

export const getAccountingEndpoints = (params = {}) => {
    const qs = Object.keys(params).length ? '?' + new URLSearchParams(params).toString() : '';
    return request('get', `/accounting-config/endpoints${qs}`);
};
export const createAccountingEndpoint = (data) =>
    request('post', '/accounting-config/endpoints', data);
export const updateAccountingEndpoint = (id, data) =>
    request('put', `/accounting-config/endpoints/${id}`, data);
export const deleteAccountingEndpoint = (id) =>
    request('delete', `/accounting-config/endpoints/${id}`);

export const getAccountingDocumentTypes = () =>
    request('get', '/accounting-config/document-types');
export const getAccountingSchema = (documentType) =>
    request('get', `/accounting-config/schema/${documentType}`);

export const getAccountingFieldMappings = (providerId, documentType) =>
    request('get', `/accounting-config/field-mappings?provider_id=${providerId}&document_type=${documentType}`);
export const createAccountingFieldMapping = (data) =>
    request('post', '/accounting-config/field-mappings', data);
export const updateAccountingFieldMapping = (id, data) =>
    request('put', `/accounting-config/field-mappings/${id}`, data);
export const deleteAccountingFieldMapping = (id) =>
    request('delete', `/accounting-config/field-mappings/${id}`);
export const testAccountingMapping = (data) =>
    request('post', '/accounting-config/field-mappings/test', data);

// ============================================
// SINCRONIZACIÓN CLIENTES ↔ CONTABLE
// ============================================
export const syncMasiva = () =>
    request('post', '/clientes/sync/masiva');
export const syncIndividual = (usuarioId) =>
    request('post', `/clientes/sync/individual/${usuarioId}`);
export const buscarEnContable = (identification) =>
    request('get', `/clientes/sync/buscar-en-contable?identification=${encodeURIComponent(identification)}`);

// Items — nuevas funciones spec 008
export const getItemsActivos = (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return request('get', `items${query ? '?' + query : ''}`);
};

export const getItemsInactivos = (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return request('get', `items/inactivos${query ? '?' + query : ''}`);
};

export const getItemsTodos = () => request('get', 'items/todos');

export const getItemsContable = (start = 0, limit = 30, name = '') => {
    const params = `start=${start}&limit=${limit}${name ? `&name=${encodeURIComponent(name)}` : ''}`;
    return request('get', `items/contable/lista?${params}`);
};

export const inactivarItem = (id, force = false) =>
    request('put', `items/${id}/inactivar${force ? '?force=true' : ''}`, {});

export const activarItem = (id) => request('put', `items/${id}/activar`, {});

export const vincularItemContable = (id, contabilidad) =>
    request('put', `items/${id}/vincular-contable`, { contabilidad });

export const migrarItemsEstado = () => request('put', 'items/migrar-estado', {});
// ==================== ACTAS POR OT (TIN-15) ====================

/**
 * Lista las actas asociadas a una OT con sus equipos populados.
 * Endpoint: GET /api/Actas/ot/:otId
 * @param {string} otId  ID de la OT
 * @param {number} [limit=100]
 */
export const getActasPorOt = (otId, limit = 100) =>
    request('get', `Actas/ot/${otId}?limit=${limit}`);

// ==================== SEGUIMIENTO EQUIPMENTS IN OT (tabs /otlista/total) ====================
// Listado paginado por estado + filtros. Devuelve resultados en response.data.data.
export const postSeguimientoEquipos = (body = {}, page = 1, perPage = 20) =>
    request('post', `/EqInOt/seguimiento?page=${page}&perPage=${perPage}`, body);

// Transición manual de estado (finalizar | aprobar | entregar). No genera HT.
// Requiere permiso ACCIONES_SEGUIMIENTO_EQUIPO.
export const patchTransicionEquipo = (id, accion) =>
    request('patch', `/EqInOt/${id}/transicion`, { accion });

// Transición manual en lote. Respuesta en response.data.data = { exitosos, fallidos }.
// Requiere permiso ACCIONES_SEGUIMIENTO_EQUIPO. Máximo 200 ids por request.
export const postSeguimientoBulkTransicion = (ids, accion) =>
    request('post', '/EqInOt/seguimiento/bulk-transicion', { ids, accion });

// Conteo batch por estado para los badges de los tabs de seguimiento.
// Respuesta en response.data.data = { Procesado, Finalizado, Aprobado }.
export const postSeguimientoCount = (estados = ['Procesado', 'Finalizado', 'Aprobado']) =>
    request('post', '/EqInOt/seguimiento/count', { estados });

// ==================== NOTAS DE OT ====================
// Reemplazan el campo legacy `observacion`. Las de tipo 'cierre' / 'cancelacion'
// las genera el backend desde /cerrar y /cancelar y no se pueden eliminar.

export const getOtNotas = (otId) =>
    request('get', `Ot/${otId}/notas`);

export const agregarOtNota = (otId, descripcion) =>
    request('post', `Ot/${otId}/notas`, { descripcion });

export const eliminarOtNota = (otId, notaId) =>
    request('delete', `Ot/${otId}/notas/${notaId}`);

export const cerrarOtConNota = (otId, descripcion) =>
    request('post', `Ot/${otId}/cerrar`, { descripcion });

export const cancelarOtConNota = (otId, descripcion) =>
    request('post', `Ot/${otId}/cancelar`, { descripcion });
